import { useQuery } from '@tanstack/react-query'
import { useAuctionsHttpClient } from '@omnea-app/fe-auctions/useAuctionsHttpClient'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'

const getMyActiveAuctionsQueryKey = 'myAuctionsQueryKey'

export const useGetMyActiveAuctions = () => {
  const auctionsHttpClient = useAuctionsHttpClient()
  const { AUCTIONS } = useFeatureFlags()

  return useQuery({
    queryKey: [getMyActiveAuctionsQueryKey],
    enabled: AUCTIONS,
    queryFn: async () => {
      const { data, error } = await auctionsHttpClient.GET('/')
      throwIfApiError(error)
      return data
    },
  })
}
